var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0877 5.75724C21.9545 5.22924 21.3017 4.79844 20.6357 4.79844H12.4589C11.7941 4.79844 10.8629 4.41684 10.3925 3.95004L9.67725 3.24444C9.20685 2.77764 8.27685 2.39844 7.61205 2.39844H3.70605C3.04005 2.39844 2.43526 2.93484 2.36206 3.59124L2.01166 7.19844H22.3289L22.0877 5.75724ZM23.2961 8.39844H0.707255C0.610329 8.3985 0.514485 8.41881 0.425863 8.45806C0.33724 8.49731 0.257793 8.55464 0.19261 8.62638C0.127428 8.69811 0.0779469 8.78267 0.0473372 8.87464C0.0167275 8.9666 0.00566393 9.06395 0.0148552 9.16044L1.12246 20.7632C1.14452 20.9918 1.25088 21.2039 1.42081 21.3583C1.59073 21.5127 1.81206 21.5983 2.04166 21.5984H21.9617C22.1912 21.5983 22.4126 21.5127 22.5825 21.3583C22.7524 21.2039 22.8588 20.9918 22.8809 20.7632L23.9885 9.16044C23.9976 9.06395 23.9866 8.9666 23.956 8.87464C23.9254 8.78267 23.8759 8.69811 23.8107 8.62638C23.7455 8.55464 23.6661 8.49731 23.5774 8.45806C23.4888 8.41881 23.393 8.3985 23.2961 8.39844Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaFolder);
export default __webpack_public_path__ + "static/media/media-folder.9e625bc3c7ea214578c2950e9242ddcb.svg";
export { ForwardRef as ReactComponent };